import { FC } from 'react';
import { css } from '@mildang/styled-system/css';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import MildangStudentLogo from '@mildang/design-system-legacy/esm/svgs/logo/MildangStudentLogo_v2';
import Slearn from '@mildang/design-system-legacy/esm/svgs/logo/Slearn';
import Laschool from '@mildang/design-system-legacy/esm/svgs/logo/Laschool';
import AfterSchoolLogo from '@mildang/design-system-legacy/esm/svgs/logo/AfterSchoolLogo';
import Link from 'next/link';
import { select } from '@shared/constants/projectTarget';

// MUI의 레이어 밖 기본 스타일보다 Panda 반응형 스타일을 우선한다.
const rootStyle = css({ position: { base: 'static!', sm: 'fixed!' } });
const loginLinkStyle = css({ display: { base: 'none!', sm: 'inline-flex!' } });
const toolbarStyle = css({
  display: 'grid',
  justifyContent: 'space-between',
  gridTemplateColumns: 'auto auto',
});
const logoStyle = css({
  width: 'auto',
  height: 'calc(token(spacing.28) + token(spacing.2))',
});
interface ISignupHeaderProps {}

const SignupHeader: FC<ISignupHeaderProps> = () => {
  return (
    <AppBar color="transparent" elevation={0} className={rootStyle}>
      <Toolbar className={toolbarStyle}>
        {select({
          _default: <MildangStudentLogo className={logoStyle} />,
          slearn: <Slearn />,
          laschool: <Laschool />,
          afterSchool: <AfterSchoolLogo />,
        })}
        <Link href="/signup" passHref>
          <Button className={loginLinkStyle} component="a" color="primary" variant="contained">
            회원가입
          </Button>
        </Link>
      </Toolbar>
    </AppBar>
  );
};

export default SignupHeader;
